<template>
  <PageVC class="table-intro">
    <div class="a-container">
      <HUILoadingView v-if="!order || !entered" />
      <template v-else>
        <h1
          class="a-page-title"
        >Velkommen til bord {{order.table_description}} på {{order.restaurant_name}}</h1>
        <p
          class="a-page-subtitle"
        >Her kan du bestille mere mad eller flere drikkevarer, se hvad du allerede har bestilt, eller betale din regning.</p>
        <div class="a-button-group a-button-group--stacked">
          <RouterButton
            theme="green"
            :to="{ name: routes.TABLE_MENU, params: { orderToken: $route.params.orderToken }}"
          >Bestil</RouterButton>
          <RouterButton
            :to="{ name: routes.TABLE_CART, params: { orderToken: $route.params.orderToken }}"
          >Vis regning</RouterButton>
          <RouterButton
            theme="red"
            :to="{ name: routes.TABLE_CART, params: { orderToken: $route.params.orderToken }}"
            :disabled="orderLines.length === 0 || numUnsentItems !== 0 || order.status === OrderStatus.CLOSED"
          >Betal</RouterButton>
        </div>
      </template>
    </div>
  </PageVC>
</template>

<script>
import { HUILoadingView, HUIButton, HUIRating, HUITextInput } from '@/halifax-ui'
import TableBase from '@/views/TableBase'
import PageVC from '@/containers/PageVC'
import RouterButton from '@/containers/RouterButton'
import { OrderStatus } from '@/store/order'

export default {
  extends: TableBase,
  components: {
    PageVC,
    HUILoadingView,
    HUIButton,
    RouterButton
  },
  data() {
    return {
      OrderStatus
    }
  },
  computed: {
    numUnsentItems() {
      return this.orderLines.reduce((accumulatedQuantity, orderLine) => {
        if (!orderLine.prepared_at) {
          accumulatedQuantity += 1
        }
        return accumulatedQuantity
      }, 0)
    }
  },
  methods: {}
}
</script>

<style lang="scss">
@import '~@/scss/variables';
@import '~@/halifax-ui/src/scss/framework';

.table-intro {
  $module: '.table-intro';
}
</style>
